export function Docs() {
  return (
    <div className="docs">
      <h1>Документация</h1>
      <p className="muted">Создавайте ботов в svoisozvon. Выпустите ключ, авторизуйтесь, отправляйте и принимайте сообщения.</p>

      <h2>Быстрый старт</h2>
      <ol className="steps">
        <li>Войдите в <span className="mono">консоль</span> и нажмите <strong>Новый ключ</strong>.</li>
        <li>Задайте боту имя и, при желании, описание.</li>
        <li>Скопируйте <strong>токен</strong> — это и есть ваш API-ключ.</li>
        <li>Передавайте его в заголовке <span className="mono">Authorization: Bot &lt;токен&gt;</span>.</li>
      </ol>

      <h2>Базовый URL и авторизация</h2>
      <p>Все эндпоинты находятся по адресу:</p>
      <pre><code>https://api.podryvanov.ru/api/bot</code></pre>
      <p>Каждый запрос авторизуется вашим ключом как <em>Bot</em>-токен:</p>
      <pre><code>Authorization: Bot &lt;ваш-ключ&gt;</code></pre>

      <h2>Информация о боте</h2>
      <pre><code>{`curl https://api.podryvanov.ru/api/bot/me \\
  -H "Authorization: Bot $TOKEN"
# → { "bot": { "id", "name", "username", "avatar" } }`}</code></pre>

      <h2>Отправить сообщение</h2>
      <pre><code>{`curl https://api.podryvanov.ru/api/bot/sendMessage \\
  -H "Authorization: Bot $TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{
    "chatId": "<id-чата>",
    "text": "Привет от моего бота"
  }'`}</code></pre>
      <p>
        Необязательные поля: <code>attachmentUrl</code>, <code>attachmentType</code>,
        <code>attachmentName</code>, <code>replyToId</code>. Лимит: 120 сообщений в минуту.
      </p>

      <h2>Открыть личный чат</h2>
      <p>Начните (или получите) диалог 1:1 с пользователем, чтобы бот мог ему написать:</p>
      <pre><code>{`curl https://api.podryvanov.ru/api/bot/chats/dm \\
  -H "Authorization: Bot $TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{ "username": "<юзернейм>" }'`}</code></pre>

      <h2>Чаты и история</h2>
      <pre><code>{`GET /api/bot/chats
GET /api/bot/chats/:chatId/messages`}</code></pre>

      <h2>Вебхуки</h2>
      <p>Зарегистрируйте URL, чтобы получать входящие события вместо опроса:</p>
      <pre><code>{`curl https://api.podryvanov.ru/api/bot/webhook \\
  -H "Authorization: Bot $TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{ "url": "https://your-app.example/hook" }'`}</code></pre>
      <p>Посмотреть — <code>GET /webhook</code>, удалить — <code>DELETE /webhook</code>.</p>

      <h2>Отзыв ключа</h2>
      <p>
        Отзовите ключ в консоли — его токен сразу перестанет работать. Храните ключ в
        секрете: любой, у кого он есть, может действовать от имени вашего бота.
      </p>
    </div>
  )
}
